export const EMPTY_CLASS_MESSAGE =
  "担当するクラスが設定されていません。\n学校管理者画面から担当クラスを設定してください。";
